import { Component, ViewChild } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { presetStatus, presetType } from "../../../../../shared/constants/preset-constant";
import { PhotoService } from "../../../../photo/services/photo.service";
import { NgxMasonryOptions } from "ngx-masonry";
import { PhotoCardComponent } from "../../../../../shared/components/photo-card/photo-card.component";
import { PresetService } from "../../../../../shared/services/preset.service";
import { forkJoin } from 'rxjs';
import * as _ from 'lodash';
import AppShareHelper from "../../../../../shared/utils/helper";
import { PopupMarkerComponent } from "../../../../../shared/components/popup-marker/popup-marker.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../../user/services/user.service";
import { CamerallaAuthService } from "../../../../../shared/services/authentication-services/cameralla-auth.service";
import { LanguageConstant } from "../../../../../shared/constants/language-constant";
import { GroupService } from "../../../../user/services/group.service";

@Component({
    selector: 'app-battle-details',
    templateUrl: './battle-details.html',
})
export class BattleDetailsComponent {
    constructor(protected presetService: PresetService,
                protected toastr: ToastrService,
                protected route: ActivatedRoute,
                protected camerallaAuthService: CamerallaAuthService,
                protected _modalService: NgbModal,
                protected userService: UserService,
                protected photoService: PhotoService,
                protected groupService: GroupService,
                protected router: Router) {
        this.localUserId = +this.camerallaAuthService.getLocalUserInfo()['id'];
    }

    model: any = {};
    photos = [];
    public get completeBattleStatus () {
        return presetStatus.COMPLETED
    }
    @ViewChild('photoZone') photoZone;
    localUserId = null;
    canGetDetailPromise = AppShareHelper.defer();
    private battleRoute = '/preset/battles';

    ngOnInit() {
        this.userService.getPersonalDetails(this.localUserId).then((user: any) => {
            this.getPresetDetail(this.route.snapshot.paramMap.get('battleId'), user);
        })
    }
    
    private getPresetDetail(battleId, user) {
        this.presetService.getPresetDetail(battleId).subscribe((res:any) => {
            if (!res.Data) {
                return this.navigateToBattles();
            }
            
            if (res.Data.type !== presetType.Battle) {
                return this.navigateToBattles();
            }
            
            this.processPresetDetail(res.Data, user);
        });
    }
    
    private processPresetDetail(presetData, user) {
        if (presetData.groupId) {
            this.validateGroupAccess(presetData.groupId).then(canAccess => {
                if (canAccess) {
                    this.setPresetData(presetData, user);
                } else {
                    this.navigateToBattles();
                }
            });
        } else {
            this.setPresetData(presetData, user);
        }
    }
    
    private validateGroupAccess(groupId) {
        return this.groupService.getMyGroups(this.localUserId, 'joined').toPromise()
            .then((groups: any) => {
                if (groups.Data) {
                    let groupIds = groups.Data.map(group => +group.groupId) || [];
                    return groupIds.includes(groupId);
                }
                return false;
            }).catch(() => false);
    }
    
    private setPresetData(presetData, user) {
        this.model = presetData;
        this.setLanguageSpecificDescription(user);
        this.getBattleResult();
    }
    
    private setLanguageSpecificDescription(user) {
        if (user.preferredLanguage === LanguageConstant.ENG && this.model.language && this.model.language.en) {
            this.model.description = this.model.language.en.description;
        }
    }
    
    navigateToBattles() {
        this.router.navigate([this.battleRoute]);
    }
    
    public renderImageOptions: NgxMasonryOptions = {
        transitionDuration: '1s',
        itemSelector: '.grid-item',
        horizontalOrder: false
    };

    trackByFn(index, item) {
        return item.id;
    }

    public updateMansoryLayout() {
        PhotoCardComponent.numberOfNewPhotoLoaded = 0;
        setTimeout(() => {
            this.photoZone._msnry.reloadItems();
            this.photoZone._msnry.layout();
        }, 300);
    }


    calculateImageSize(photo) {
        return AppShareHelper.calculateImageSize(photo);
    }

    getBattleResult() {
        forkJoin([this.photoService.getPhotosById(this.model.photoIds.split(',')),
            this.presetService.getBattlePresetResult(this.route.snapshot.paramMap.get('battleId'))]).subscribe((results: any) => {
            const ratingResult = results[1].Data.result || [];
            const parsedResult = {};
            ratingResult.forEach((item) => {
                parsedResult[item.objectId] = item.score;
            })

            results[0].Data.forEach((item) => {
                item.score = parsedResult[item.id] || 0;
                if (results[1].Data.ownerRating && results[1].Data.ownerRating.objectId == item.id) {
                    item.rated = true;
                }
            })

            if (this.model.status === presetStatus.COMPLETED) {
                this.photos = _.orderBy(results[0].Data, 'score', 'desc');
            } else {
                this.photos = results[0].Data;
            }

            this.updateMansoryLayout();
            setTimeout(() => {
                this.photoZone._msnry.options.transitionDuration = '1s';
            }, 600);
        })
    }

    vote(photoId) {
        if (new Date() > new Date(this.model.endTime)) {
            this.toastr.error('The battle is finished');
            return;
        }

        this.presetService.vote({
            presetId : this.route.snapshot.paramMap.get('battleId'),
            objectType: "photo",
            objectId: photoId
        }).subscribe((res) => {
            this.toastr.success('Cast a vote successfully');
            this.getBattleResult();
        })
    }

    viewDetail(photo) {
        const modalRef = this._modalService.open(PopupMarkerComponent, {
            centered: true,
            size: "lg"
        });
        modalRef.componentInstance.title = photo.title
        modalRef.componentInstance.body = `<img src="${photo.thumbnail}" style="max-width: 100%" /><br>` + `<p>${photo.vision}</p><br>`;
    }
}
